import { Grid } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import { CAR_TYPE_LIST } from 'src/utils/constants/BuyPolicy'
import Button from '@mui/material/Button'
import { COLORS } from 'src/utils/Themes/colors'

const CarTypeSelector = ({ carDetails, handleChange }) => {
  const classes = useStyles()

  const handleClick = (carType) => {
    handleChange({ carType })
  }

  const isSelected = (carType) => {
    return carDetails?.carType?.value === carType?.value
  }

  return (
    <div>
      <div className={classes.carContainer}>
        <span className={classes.carType}>Which Car?</span>
      </div>
      <Grid container spacing={2} className={classes.carListContainer}>
        {CAR_TYPE_LIST?.map((carType) => {
          return (
            <Grid
              item
              xs={4}
              md={3}
              lg={3}
              className={classes.carTypeContainer}
              key={carType?.value}
            >
              <span
                onClick={() => handleClick(carType)}
                className={`${classes.carTypeButton} ${
                  isSelected(carType) ? classes.selected : null
                }`}
              >
                <span className={classes.label}>{carType?.label}</span>
              </span>
            </Grid>
          )
        })}
      </Grid>
      <div className={classes.viewButtonContainer}>
        <Button variant='contained' className={classes.viewButton}>
          View more..
        </Button>
      </div>
    </div>
  )
}

export default CarTypeSelector

const useStyles = makeStyles({
  carContainer: {
    textAlign: 'center',
    marginBottom: '10px',
    marginTop: '-15px',
  },
  carType: {
    fontSize: '16px',
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  carListContainer: {
    width: '100% !important',
    height: '100%!important ',
    padding: '5px 20px !important',
    marginLeft: '-4px !important',
  },
  carTypeContainer: {
    width: '20%',
    cursor: 'pointer',
  },
  carTypeButton: {
    width: '100px',
    height: '32px',
    display: 'flex',
    border: '1px solid #CDCDCD',
    borderRadius: '5px',
    cursor: 'pointer',
    justifyContent: 'center',
    alignItems: 'center',
    '&:hover': {
      boxShadow: '0px 0px 10px 0px #4DC3E3',
    },
  },
  selected: {
    boxShadow: '0px 0px 10px 0px #4DC3E3',
  },
  label: {
    color: COLORS.BLACK,
    fontSize: '12px',
    width: '100%',
    textAlign: 'center',
  },
  viewButtonContainer: {
    textAlign: 'center',
    padding: '10px',
  },
  viewButton: {
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%) !important',
    color: '#FFFFFF !important',
    fontWeight: '400 !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    borderRadius: '5px !important',
  },
})
